import { memo, useEffect, useState } from "react";
import { Button, Popconfirm, Space, Table, TableProps, Tag } from "antd";
import { useTranslation } from "react-i18next";
import { mdlTablePagination } from "../../models/ui-models/TablePagination";
import { QuestionCircleOutlined } from '@ant-design/icons';
import $ from 'jquery';
import { mdlBoard } from "../../models/domain/Board";

export type BoardTableProps = {
    dataSource?: mdlBoard[];
    onDelete?: Function;
    onEdit?: Function;
    pagination: mdlTablePagination;
    onTableParamsChange?: Function;
    rowSelectionChange?: Function;
}

export const BoardTable = memo(function BoardTable(props: BoardTableProps) {
    const { t } = useTranslation();
    const [selectionType, setSelectionType] = useState<'checkbox' | 'radio'>('checkbox');
    const rowSelection: TableProps<mdlBoard>['rowSelection'] = {
        onChange: (selectedRowKeys: React.Key[], selectedRows: mdlBoard[]) => {
            props.rowSelectionChange && props.rowSelectionChange(selectedRows);
        },
    };

    const columns: TableProps<mdlBoard>['columns'] = [
        {
            title: t("definitions.boards.name"),
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: t("common.actions"),
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Button type="primary" className="btn-success" onClick={() => props.onEdit ? props.onEdit(record.id) : undefined}>
                        {t("common.edit")}
                    </Button>
                    <Popconfirm
                        title={t("common.deleteWarning")}
                        description={t("common.deleteDescription")}
                        okText={t("common.okConfirm")}
                        cancelText={t("common.cancelConfirm")}
                        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                        onConfirm={() => props.onDelete ? props.onDelete(record.id) : undefined}
                    >
                        <Button type="primary" danger>
                            {t("common.delete")}
                        </Button>
                    </Popconfirm>

                </Space>
            ),
        },
    ];

    const handleRowDoubleClick = (e: React.MouseEvent<HTMLInputElement>, board: mdlBoard) => {
        if (!$(e.target).hasClass("ant-table-row-expand-icon"))
            props.onEdit && props.onEdit(board.id);
    }

    const handleTableChange: TableProps<mdlBoard>['onChange'] = (pagination, filters, sorter) => {
        props.onTableParamsChange && props.onTableParamsChange(pagination, filters);
    }

    return (
        <>
            {
                props.dataSource
                &&
                <Table<mdlBoard>
                    className="mt-2"
                    onRow={(reservation) => ({
                        onDoubleClick: (e) => handleRowDoubleClick(e, reservation),
                    })}
                    onChange={handleTableChange}
                    size="middle"
                    columns={columns}
                    pagination={props.pagination}
                    scroll={{ x: 'max-content' }}
                    dataSource={props.dataSource.map((customer: mdlBoard, index: number) => ({ ...customer, key: index }))}
                    rowSelection={{ type: selectionType, ...rowSelection }}
                />
            }
        </>
    )
})